import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBvn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M22 9.75a.75.75 0 0 0 0-1.5H2a.75.75 0 0 0 0 1.5h20Zm-6.523 3.519.46.962L17.25 16.5h1.142v-4.799h-.983v3.231h-.021l-.46-.962-1.314-2.269h-1.141V16.5h.983v-3.231h.02ZM11.115 16.5l-1.547-4.799h1.06l.714 2.303.378 1.506h.021l.364-1.506.715-2.303h1.025l-1.56 4.799h-1.17Zm-3.174-4.799h-2.33V16.5h2.543c.18 0 .344-.034.495-.103.152-.073.282-.172.392-.296a1.503 1.503 0 0 0 .35-.97c.001-.205-.036-.38-.109-.522a1.005 1.005 0 0 0-.261-.343 1.127 1.127 0 0 0-.708-.261v-.042c.123-.004.238-.025.343-.062a.74.74 0 0 0 .282-.185.837.837 0 0 0 .193-.317 1.28 1.28 0 0 0 .075-.467c0-.371-.112-.67-.337-.894-.22-.224-.529-.337-.928-.337ZM7.86 15.62H6.656v-1.1h1.203c.137 0 .245.039.323.117.082.073.124.179.124.316v.234a.423.423 0 0 1-.124.323.452.452 0 0 1-.323.11Zm-.165-1.952H6.656V12.58h1.038c.137 0 .245.04.323.117a.437.437 0 0 1 .117.323v.206a.437.437 0 0 1-.117.324.437.437 0 0 1-.323.117Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M22.75 17A2.75 2.75 0 0 1 20 19.75H4A2.75 2.75 0 0 1 1.25 17V7A2.75 2.75 0 0 1 4 4.25h16A2.75 2.75 0 0 1 22.75 7v10ZM20 18.25c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h16Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorBvn;
